<template>
    <App title="Admins">
        <div class="page-header mb-4">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <h4 class="fw-semibold mb-1">Admins</h4>
                    <p class="fs-sm text-muted mb-0">Manage administrators, assign roles, and track status.</p>
                </div>
                <a :href="route('admin.page.create')" class="btn btn-primary btn-sm"> <i class="fas fa-user-plus me-1"></i> New Admin </a>
            </div>
        </div>

        <Block>
            <Datatable :options="options" />
        </Block>
    </App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Component, toNative, Vue } from 'vue-facing-decorator'

@Component({
    components: {
        App,
        Block,
        Datatable,
    },
})
class Group extends Vue {
    get buttons() {
        let buttons: any[] = []
        buttons.push('refresh')
        buttons.push({
            extend: 'create',
            attr: {
                href: this.route('admin.page.create'),
            },
        })
        buttons.push('trashed')

        return buttons
    }

    get columns() {
        let columns: any[] = []
        columns.push({
            data: 'id',
            orderable: true,
            name: 'id',
            title: 'Id',
        })

        columns.push({
            data: 'fullname',
            title: 'Name',
        })
        columns.push({
            data: 'email',
            title: 'email',
            orderable: true,
            name: 'title',
        })
        columns.push({
            data: 'phone',
            title: 'Phone',
            orderable: true,
            name: 'phone',
        })

        columns.push({
            data: 'role',
            title: 'Role',
            orderable: true,
            name: 'role',
        })

        columns.push({
            data: 'created_at',
            title: 'Registered',
            render: CellRender.date(),
            orderable: true,
            name: 'created_at',
        })

        columns.push(Column.actions(this.$gate, { forceDelete: import.meta.env.VITE_APP_ENV !== 'production' }))

        return columns
    }

    get options() {
        return {
            ajax: {
                url: this.route('admin.ajax.table'),
                method: 'POST',
            },
            buttons: this.buttons,
            columns: this.columns,
        }
    }
}
export default toNative(Group)
</script>
